import { RouteType } from "types/RouteType";
import type DeviceApprovalStore from "./DeviceApprovalStore";

const storeOf = (rootStore: unknown) =>
  (rootStore as { deviceApprovalStore?: DeviceApprovalStore }).deviceApprovalStore;

/**
 * Device sign-in. A device (a Gantry box) is told to send its person to
 * `{web origin}/device?code=XXXX-XXXX` (the API's `verificationUri`). That
 * short, top-level address forwards to the real page under the app layout,
 * keeping `?code=`; the page itself requires a signed-in session, so a person
 * who is not signed in signs in first (any method, two-factor honoured).
 *
 * Hidden from menus: it is reached from a device, never browsed to.
 */
const deviceRoutesList: RouteType[] = [
  {
    name: "Device Sign-in Link",
    path: "/device",
    layout: "",
    requiresAuth: false,
    requiresAdmin: false,
    requiresPermission: false,
    enableAutoFind: false,
    offlineCapable: false,
    hidden: true,
    beforeEnter: ({ rootStore, queryParams }) => {
      void rootStore.routerStore?.goTo("Approve Device", {}, queryParams);
      return false;
    },
  },
  {
    name: "Approve Device",
    path: "/device",
    layout: "/app",
    viewportCard: {
      header: { title: "Approve a device" },
      body: {
        component: () => import("./DeviceApproval.Body"),
        grayBackground: true,
      },
    },
    requiresAuth: true,
    requiresAdmin: false,
    requiresPermission: false,
    enableAutoFind: false,
    hidden: true,
    onEnter: ({ rootStore, queryParams }) => {
      storeOf(rootStore)?.initialize((queryParams as Record<string, unknown> | undefined)?.code);
    },
    onExit: ({ rootStore }) => {
      storeOf(rootStore)?.reset();
    },
  },
];

export default deviceRoutesList;
